export enum DateInputEnum {
    DATE_TIME = 'DATE_TIME',
    DATE_TIME_OLD = 'DATE_TIME_OLD',
    DATE = 'DATE',
    TIME = 'TIME'
}
